import { useState, useEffect } from 'react'
import './TestimonialSlider.css'

interface Testimonial {
  id: number
  name: string
  title: string
  company: string
  text: string
  rating: number
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Jason Balderston',
    title: 'Facilities and Operations Manager',
    company: 'Oregon State University',
    text: 'I\'ve worked with Laboratory Specialists for nearly 20 years and they are always my first call.    Many of my projects are quite small but they always approach them with the same enthusiasm and commitment to great service as the larger projects.   Because they offer turnkey solutions and I get to work with the same people from design through installation, I can save time and gain a certain peace of mind knowing that the person I begin the project with will be there in the end and be accountable.', 
    rating: 5
  },
  {
    id: 2,
    name: 'Leanne Tollerud',
    title: 'Project Manager',
    company: 'Advance Cabinet Designs, Inc.',
    text: 'I\'ve worked with Laboratory Specialists for over 30 years on both large and small projects.  The customer service has always been excellent.  Quick turn around on shop drawings.  Great follow thru all the way to the end of the project.  I would highly recommend to anyone looking for Epoxy tops or laboratory equipment.',
    rating: 5
  }

]

function TestimonialSlider() {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  const currentTestimonial = testimonials[currentIndex]

  return (
    <div className="testimonial-slider">
      <div className="testimonial-card">
        <div className="testimonial-rating">
          {'★'.repeat(currentTestimonial.rating)}
        </div>
        <blockquote className="testimonial-text">
          "{currentTestimonial.text}"
        </blockquote>
        <div className="testimonial-author">
          <div className="testimonial-author-info">
            <div className="testimonial-author-name">{currentTestimonial.name}</div>
            <div className="testimonial-author-title">
              {currentTestimonial.title}, {currentTestimonial.company}
            </div>
          </div>
        </div>
      </div>
      <div className="testimonial-dots">
        {testimonials.map((_, index) => (
          <button
            key={index}
            className={`testimonial-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`View testimonial ${index + 1}`}
          />
        ))}
      </div>
    </div>
  )
}

export default TestimonialSlider
